import { render, staticRenderFns } from "./unionList.vue?vue&type=template&id=207f9de6&"
import script from "./unionList.vue?vue&type=script&lang=js&"
export * from "./unionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('207f9de6')) {
      api.createRecord('207f9de6', component.options)
    } else {
      api.reload('207f9de6', component.options)
    }
    module.hot.accept("./unionList.vue?vue&type=template&id=207f9de6&", function () {
      api.rerender('207f9de6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpOpsManager/unionList.vue"
export default component.exports